var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white mt-8 mx-7.5 p-8 rounded-xl shadow-lg"},[(!_vm.competitions.length)?_c('div',{staticClass:"w-full text-center"},[_vm._v(" No data. ")]):_vm._l((_vm.competitions),function(challenge){return _c('div',{key:challenge.id,staticClass:"text-blue"},[_c('router-link',{attrs:{"to":{
        name: 'challengesDetail',
        params: { challengeId: challenge.id, challenge: challenge },
      }}},[_vm._v(" > "+_vm._s(challenge.name)+" ")])],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }